<template>
  <footer class="bg-base-200 bg-accent text-base-content pt-10 px-3">
    <div class="max-w-screen-xl mx-auto px-4 footer sm:footer-horizontal mb-4">
      <aside>
        <img :src="logoUrl" class="h-8 w-auto" />
        <p class="text-sm text-gray-500">
          {{ t("footer.site.tagline") }}
        </p>
      </aside>
      <nav>
        <a href="/about"
          ><h6 class="footer-title">
            {{ t("footer.company.title") }}
          </h6></a
        >
        <a href="/total-package/order">{{ t("footer.company.links.pricing") }}</a>

        <a href="/contact" class="link link-hover">
          {{ t("footer.company.links.contact") }}
        </a>

        <a href="https://api.siteoplossing.nl/auth/login" class="link link-hover">
          {{ t("footer.company.links.clientLogin") }}
        </a>
      </nav>
      <nav>
        <a href="/legal/overview"
          ><h6 class="footer-title">{{ t("footer.legal.title") }}</h6></a
        >
        <a href="/legal/terms-and-conditions" class="link link-hover">
          {{ t("footer.legal.links.terms") }}
        </a>
        <a href="/legal/privacy-policy" class="link link-hover">
          {{ t("footer.legal.links.privacy") }}
        </a>
        <a href="/legal/cookie-policy" class="link link-hover">
          {{ t("footer.legal.links.cookie") }}
        </a>
        <a href="/legal/sla" class="link link-hover">
          {{ t("footer.legal.links.sla") }}
        </a>
        <a href="/legal/aup" class="link link-hover">
          {{ t("footer.legal.links.aup") }}
        </a>
      </nav>
    </div>
    <InlineLiveChat />
    <AcceptedPaymentsSection variant="footer" />
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import InlineLiveChat from "@/components/forms/ChatLive/InlineLiveChat.vue";
import AcceptedPaymentsSection from "@/components/sections/accepted-payments/AcceptedPaymentsSection.vue";

const { t } = useI18n();
const logoUrl = "/images/logo/logo.svg";
</script>
